import * as R from 'ramda';
import { EventPayload } from '../../../events';
import { Validation, ValidationStep } from '../../../services/validation';
import DefaultValidationEventBuilder, { DefaultValidationEvent } from './DefaultValidationEventBuilder';

type IdentityTokenValidationEvent = DefaultValidationEvent & {
  identityAuthToken?: string;
};

export default class IdentityTokenValidationEventBuilder extends DefaultValidationEventBuilder {
  private identityAuthToken?: string;

  constructor(private stepContainingToken: ValidationStep) {
    super();
  }

  override withCompletedValidation(validation: Validation): void {
    const identityTokenStep = R.find((step) => step.name === this.stepContainingToken, validation.steps) || {
      value: {},
    };
    this.identityAuthToken = R.propOr(undefined, 'identityAuthToken', identityTokenStep.value);
  }

  override build(): EventPayload {
    const baseResult = super.build();

    return {
      ...baseResult,
      identityAuthToken: this.identityAuthToken,
    } as IdentityTokenValidationEvent;
  }
}
